// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'

// gets all the radio companies from redux
// NOTE: this does not fetch any companies.
// that is handled by a parent calling fetchAndAddRadioSettings.

// NOTE: this component must be assigned async validate by redux-form.

const RadioCompanies = ({ companies, handleSelection, idRoot, name }) => (
  <Field
    component={AutoSuggest}
    handleSelection={handleSelection}
    id={`${idRoot}-radio-company`}
    label={`Manufacturer`}
    name={name || 'company'}
    optionKey={`companyName`}
    staticSuggestions={companies} />
)

RadioCompanies.propTypes = {
  companies: object.isRequired,
  handleSelection: func.isRequired,
  idRoot: string.isRequired,
  name: string,
}

const mapStateToProps = ({ domain }) => ({
  companies: domain.getIn(['radioSettings', 'companies']),
})

export default connect(
  mapStateToProps,
)(RadioCompanies)
